module.exports = __webpack_public_path__ + "e7752350df48f09e7fd75e5b82e94186.svg";